<template>
  <div class="register-wrap">
    <authLeft v-if="$mq != 'sp' && $mq != 'tb'" />
    <div class="register-right">
      <div class="register-form">
        <div class="register-form-title">メールアドレス認証用のメールをご確認ください</div>
        <img class="register-form-img" src="../../assets/new_message.png" alt />
        <div>メールをご確認いただき、記載されているURLをクリックして登録を完了させてください。</div>
        <div>認証メールが届かない場合、下記をクリックして認証メールを再送信してください。</div>
        <el-button style="width:100%; margin-top:30px;" type="primary" @click="sendEmail" :disabled="loading">
          <div class="flex-row">
            認証メールを再送信
            <div class="loader--mini" v-show="loading"></div>
          </div>
        </el-button>
        <div style="margin-top: 30px">
          <router-link to="/login" class="router-link">ログイン画面に戻る</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authLeft from "./auth_left";
const root = process.env.VUE_APP_API;
const emailVerificationAPI = root + "/api/auth/email_verification";

export default {
  name: "register",
  components: {
    authLeft,
  },
  data() {
    return {
      loading: false,
      token: "",
      oemToken: "",
    };
  },
  mounted() {
    this.token = this.$route.query.token;
    this.oemToken = this.$route.query.oem_token;
  },
  methods: {
    sendEmail() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("user_token", this.token);
      if (this.oemToken) {
        params.append("oem_token", this.oemToken);
      }
      this.axios.post(emailVerificationAPI, params).then((response) => {
        if (response.data.status == "OK") {
          this.$alert(response.data.email + "宛に確認メールを送信しました。", "", {
            confirmButtonText: "OK",
          });
        } else {
          this.$alert("エラーが発生しました。しばらく時間を空けてお試しいただくか、担当者までご連絡ください。", "", {
            confirmButtonText: "OK",
          });
        }
        this.loading = false;
      });
    },
  },
  watch: {},
};
</script>

<style></style>
